<template>
<div class='wrap'>
    <el-row class="search" type="flex" justify="space-between">
        <el-button @click="handleAddAccount" type="primary" size="small">新增账号</el-button>
        <!-- <el-row>
            <el-select v-model="conditions.account" placeholder="请选择账号" size="small" class="mr10">
                <el-option v-for="(account, index) in accountList" :key="index" :label="account.username" :value="account.username"></el-option>
            </el-select>
            <el-select v-model="conditions.province" placeholder="请选择省份" filterable size="small" class="mr10">
                <el-option v-for="province in leftOption" :key="province.code" :label="province.name" :value="province.name"></el-option>
            </el-select>
            <el-select v-model="conditions.provider" placeholder="请选择供应商" filterable size="small" class="mr10">
                <el-option v-for="provider in leftOption2" :key="provider.storeCode" :label="provider.storeName" :value="provider.storeCode"></el-option>
            </el-select>
            <el-select v-model="conditions.type" placeholder="请选择单据类型" size="small" class="mr10">
                <el-option label="月结单" value="month"></el-option>
                <el-option label="普通单" value="normal"></el-option>
            </el-select>
            <el-button @click="handleSearch" type="primary" size="small">查询</el-button>
        </el-row> -->
    </el-row>
    <el-row class="table-wrap" type="flex" justify="center" align="middle">
        <el-table :data="tableData" stripe>
            <el-table-column label="账号" prop="account"></el-table-column>
            <el-table-column label="关联省份" prop="provinceNameGroup" show-overflow-tooltip></el-table-column>
            <el-table-column label="关联供应商" prop="supplierNameGroup" show-overflow-tooltip></el-table-column>
            <el-table-column label="关联单据类型" prop="auditBillTypeName"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleEdit(scope.row)" type="text">编辑</el-button>
                    <el-button @click="handleDel(scope.row)" type="text">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total">
            </el-pagination>
    </el-row>



    <!-- 新增账号 -->
      <el-dialog
        :title="type==='edit'?'编辑账号':'新增账号'"
        :visible.sync='addVisible'
        width='940px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        @close="handleDialogClose"
        destroy-on-close
      >
        <el-form ref="addForm" :model="addForm" label-width="100px">
            <el-form-item label="账号名称" prop="accountName" :rules="[{ required: true, message: '请选择账号', trigger: 'change' }]">
                <el-select v-model="addForm.accountName" :disabled="type==='edit'">
                  <el-option v-for="(account, index) in accountList" :key="index" :label="account.username" :value="account.username"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="单据类型" prop="type">
                <el-radio-group v-model="addForm.type">
                    <el-radio label="month">月结单</el-radio>
                    <el-radio label="normal">普通单</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="关联省份">
              <hm-base-transfer
                ref="provinceTransfer"
                leftName="可选省份"
                rightName="已选省份"
                :leftOption="provinceList"
                :leftProps="leftProps"
                :rightProps="leftProps"
                compareKey="code"
                @getTransferResult="getTransferResult"
              ></hm-base-transfer>
              <!-- <hm-base-transfer
                ref="provinceTransfer"
                leftName="可选省份"
                rightName="已选省份"
                :leftOption="provinceList"
                :leftProps="leftProps"
                :rightProps="leftProps"
                compareKey="code"
                @getTransferResult="getTransferResult"
              ></hm-base-transfer> -->
            </el-form-item>
            <el-form-item label="关联供货商">
              <div>
                <el-input v-model="keyWords" class="mr20" clearable placeholder="请输入供货商名称"></el-input><el-button @click="queryList" type="primary">查询</el-button>
              </div>
              <hm-base-transfer
                ref="providerTransfer"
                leftName="可选供应商"
                rightName="已选供应商"
                :leftOption="leftOption2"
                :leftProps="leftProps2"
                :rightProps="leftProps2"
                compareKey="storeCode"
                @getTransferResult="getTransferResult2"
              ></hm-base-transfer>
            </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleAddConfirm' type='primary' size='small'>确定</el-button>
          <el-button @click='addVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>
</div>
</template>
 
<script>
import HmBaseTransfer from "@/components/HmBaseTransfer";
export default {
  name: "",
  components: {
    HmBaseTransfer,
  },
  mixins: [],
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      conditions: {
        account: "",
        province: "",
        provider: "",
        type: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      addForm: {
        accountName: "",
        type: "month",
        province: "",
        provider: "",
      },
      addVisible: false,
      // 省份
      leftProps: [
        {
          name: "省份",
          value: "name",
        },
      ],
      leftOption: [
        { code: "110000", name: "北京市" },
        { code: "120000", name: "天津市" },
        { code: "130000", name: "河北省" },
        { code: "140000", name: "山西省" },
        { code: "150000", name: "内蒙古自治区" },
        { code: "210000", name: "辽宁省" },
        { code: "220000", name: "吉林省" },
        { code: "230000", name: "黑龙江省" },
        { code: "310000", name: "上海市" },
        { code: "320000", name: "江苏省" },
        { code: "330000", name: "浙江省" },
        { code: "340000", name: "安徽省" },
        { code: "350000", name: "福建省" },
        { code: "360000", name: "江西省" },
        { code: "370000", name: "山东省" },
        { code: "410000", name: "河南省" },
        { code: "420000", name: "湖北省" },
        { code: "430000", name: "湖南省" },
        { code: "440000", name: "广东省" },
        { code: "450000", name: "广西壮族自治区" },
        { code: "460000", name: "海南省" },
        { code: "500000", name: "重庆市" },
        { code: "510000", name: "四川省" },
        { code: "520000", name: "贵州省" },
        { code: "530000", name: "云南省" },
        { code: "540000", name: "西藏自治区" },
        { code: "610000", name: "陕西省" },
        { code: "620000", name: "甘肃省" },
        { code: "630000", name: "青海省" },
        { code: "640000", name: "宁夏回族自治区" },
        { code: "650000", name: "新疆维吾尔自治区" },
      ],
      provinceList: [
        { code: "110000", name: "北京市" },
        { code: "120000", name: "天津市" },
        { code: "130000", name: "河北省" },
        { code: "140000", name: "山西省" },
        { code: "150000", name: "内蒙古自治区" },
        { code: "210000", name: "辽宁省" },
        { code: "220000", name: "吉林省" },
        { code: "230000", name: "黑龙江省" },
        { code: "310000", name: "上海市" },
        { code: "320000", name: "江苏省" },
        { code: "330000", name: "浙江省" },
        { code: "340000", name: "安徽省" },
        { code: "350000", name: "福建省" },
        { code: "360000", name: "江西省" },
        { code: "370000", name: "山东省" },
        { code: "410000", name: "河南省" },
        { code: "420000", name: "湖北省" },
        { code: "430000", name: "湖南省" },
        { code: "440000", name: "广东省" },
        { code: "450000", name: "广西壮族自治区" },
        { code: "460000", name: "海南省" },
        { code: "500000", name: "重庆市" },
        { code: "510000", name: "四川省" },
        { code: "520000", name: "贵州省" },
        { code: "530000", name: "云南省" },
        { code: "540000", name: "西藏自治区" },
        { code: "610000", name: "陕西省" },
        { code: "620000", name: "甘肃省" },
        { code: "630000", name: "青海省" },
        { code: "640000", name: "宁夏回族自治区" },
        { code: "650000", name: "新疆维吾尔自治区" },
      ],

      leftProps2: [
        {
          name: "供货商名称",
          value: "storeName",
        },
      ],
      leftOption2: [],
      keyWords: "",
      workAccountRules: [],
      accountList: [],
      type: "add"
    };
  },
  created() {
    this.queryTenantBasicInfoList();
    this.getTable();
    this.init();
  },
  mounted() {},
  destroyed() {},
  methods: {
    async init() {
      const { code, result } = await this.$store.dispatch("queryEmployeeList", {
        pageNo: 1,
        pageSize: 9999,
        queryKey: "",
        orgCode: "",
        workingState: "yes",
        syncFlag: "",
        loginType: "store",
      });
      console.log("---code---", code);
      console.log("---result---", result);
      this.accountList = result.records;
    },
    async queryTenantBasicInfoList() {
      const { code, result } = await this.$store.dispatch(
        "tenantBasicInfoList"
      );

      if (code === "0") {
        this.tenantBasicInfoList = result.records;
        this.queryList();
      }
    },
    async queryList() {
      let params = {
        pageSize: 9999,
        pageNo: 1,
        keyWords: this.keyWords,
        createTimeEnd: "",
        createTimeStart: "",
      };
      if (!this.keyWords) {
        delete params.keyWords;
      }
      console.log(params);
      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      if (code === "0") {
        result.records.forEach((v) => {
          this.tenantBasicInfoList.forEach((o) => {
            if (o.tenantId === v.tenantId) {
              v.tenantName = o.tenantCompanyName;
            }
          });
        });
        this.allSupplier = result.records;
        this.leftOption2 = result.records.slice(0, 9999);
        console.log("---result.records---", result.records);
      }
    },
    /**
     * @desc 新增账号
     */
    handleAddAccount() {
      this.type = "add";
      this.addVisible = true;
    },
    /**
     * @desc 确认新增
     */
    handleAddConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const province = this.$refs.provinceTransfer.rightData;
          const provider = this.$refs.providerTransfer.rightData;
          // if (!province.length) {
          //   this.$message.warning("请选择关联省份");
          //   return;
          // }
          // if (!provider.length) {
          //   this.$message.warning("请选择关联供货商");
          //   return;
          // }
          const provinceList = province.map((v) => {
            return {
              workType: "user_name",
              workValue: this.addForm.accountName,
              configType: "province_code",
              configValue: v.code,
            };
          });
          const providerList = provider.map((v) => {
            return {
              workType: "user_name",
              workValue: this.addForm.accountName,
              configType: "supplier_code",
              configValue: v.storeCode,
            };
          });
          let params = {
            operRuleList: [
              {
                workType: "account_type",
                workValue: "-",
                configType: "declare_audit_account",
                configValue: this.addForm.accountName,
              },
              {
                workType: "user_name",
                workValue: this.addForm.accountName,
                configType: "audit_bill_type",
                configValue: this.addForm.type,
              },
              ...provinceList,
              ...providerList,
            ],
            account: this.addForm.accountName
          };
          if (this.type === "edit") {
            this.$store
              .dispatch("bulkOperAccountWorkConfig", params)
              .then((res) => {
                console.log("---res---", res);
                if (res.code === "0") {
                  this.$message({
                    type: "success",
                    message: "编辑成功!",
                  });
                  this.addVisible = false;
                  this.provinceList = JSON.parse(
                    JSON.stringify(this.leftOption)
                  );
                  this.handleSearch();
                }
              });
          } else {
            delete params.account;
            this.$store.dispatch("bulkOperWorkConfig", params).then((res) => {
              console.log("---res---", res);
              if (res.code === "0") {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.addVisible = false;
                this.provinceList = JSON.parse(JSON.stringify(this.leftOption));
                this.handleSearch();
              }
            });
            // this.addVisible = false;
          }
        }
      });
    },
    /**
     * @desc 编辑
     */
    handleEdit(row) {
      console.log("---row--", row);
      this.type = "edit";
      this.addVisible = true;
      this.$nextTick(() => {
        this.addForm.accountName = row.account;
        this.addForm.type = row.auditBillType;

        // let supplierCodeGroup = row.supplierCodeGroup.split(",");
        // let provinceNameGroup = row.provinceNameGroup.split(",");
        // const province = this.leftOption.filter(
        //   (item) => provinceNameGroup.indexOf(item.name) > -1
        // );
        // const provider = this.allSupplier.filter(
        //   (item) => supplierCodeGroup.indexOf(item.storeCode) > -1
        // );

        let supplierCodeGroup
        let provinceNameGroup
        let province
        let provider
        if(row.provinceNameGroup){
          provinceNameGroup = row.provinceNameGroup.split(",");
          province = this.leftOption.filter(
          (item) => provinceNameGroup.indexOf(item.name) > -1
        );
          province.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
        this.$refs.provinceTransfer.rightData = province;
        }
        if(row.supplierCodeGroup){
          supplierCodeGroup = row.supplierCodeGroup.split(",");
          provider = this.allSupplier.filter(
          (item) => supplierCodeGroup.indexOf(item.storeCode) > -1
        );
         provider.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
         this.$refs.providerTransfer.rightData = provider;
        }
        console.log("--allSupplier--", this.allSupplier);
        console.log("--leftOption--", this.leftOption);
        // this.$refs.provinceTransfer.rightData = province;
        // this.$refs.providerTransfer.rightData = provider;
      });
    },
    /**
     * @desc 删除
     */
    handleDel(row) {
      console.log("---row--", row);
      this.$confirm("是否确定删除该账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // const {
        //   accountId,
        //   auditBillTypeId,
        //   provinceIdGroup,
        //   restDayIdGroup,
        //   supplierIdGroup,
        //   workUpperLimitId,
        // } = row;
        // const
        // let list = []
        // if(accountId) {
        //   list = list.con
        // }
        const accountId = row.accountId ? row.accountId.split(",") : [];
        const auditBillTypeId = row.auditBillTypeId
          ? row.auditBillTypeId.split(",")
          : [];
        const provinceIdGroup = row.provinceIdGroup
          ? row.provinceIdGroup.split(",")
          : [];
        const restDayIdGroup = row.restDayIdGroup
          ? row.restDayIdGroup.split(",")
          : [];
        const supplierIdGroup = row.supplierIdGroup
          ? row.supplierIdGroup.split(",")
          : [];
        const workUpperLimitId = row.workUpperLimitId
          ? row.workUpperLimitId.split(",")
          : [];
        let ids = []
          .concat(accountId)
          .concat(auditBillTypeId)
          .concat(provinceIdGroup)
          .concat(restDayIdGroup)
          .concat(supplierIdGroup)
          .concat(workUpperLimitId);
        console.log("---ids---:", ids);
        debugger;
        this.$store
          .dispatch("removeByIds", {
            ids,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getTable();
            }
          });
      });
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "已取消删除",
      //   });
      // });
    },
    /**
     * @desc 搜索
     */
    handleSearch() {
      console.log("--conditions--", this.conditions);
      this.getTable();
    },
    /**
     * @desc 获取表格数据
     */
    async getTable() {
      // const { result } = await this.$store.dispatch("obtainAutoAllocRules");
      // this.workAccountRules = result.workAccountRules;
      // console.log("---result---, ", result);
      let params = {
        account: "", // 账号
        auditBillType: "",
        auditBillTypeName: "",
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        provinceCodeGroup: "",
        provinceNameGroup: "",
        storeNameGroup: "",
        supplierCodeGroup: "",
      };
      const { result } = await this.$store.dispatch(
        "queryAccountInfoPageList",
        params
      );
      console.log("---result---", result);
      this.tableData = result.records;
      this.total = result.total;
    },
    handleDialogClose() {
      this.addForm = {
        accountName: "",
        type: "month",
        province: "",
        provider: "",
      };
    },
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getTable();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getTable();
    },
    getTransferResult2(list) {
      console.log("list2::", list);
    },
    getTransferResult(list) {
      console.log("list::", list);
    },
  },
};
</script>
 
<style lang='scss' scoped>
.wrap {
  .search {
    padding: 18px 30px;
    margin-bottom: 20px;
    background: #fff;
  }
  .table-wrap {
    padding: 20px 30px;
    background: #fff;
    flex-direction: column;
    .el-table {
      margin-bottom: 50px;
    }
  }
}
</style>
